import { createI18n } from 'vue-i18n'
import en from './en.json'
import lv from './lv.json'
import ru from './ru.json'

export const LOCALES = ['en', 'lv', 'ru'] as const
export type Locale = (typeof LOCALES)[number]

const KEY = 'cr_locale'
const isLocale = (l: unknown): l is Locale => LOCALES.includes(l as Locale)

function initial(): Locale {
  try {
    const saved = localStorage.getItem(KEY)
    if (isLocale(saved)) return saved
  } catch {
    /* storage unavailable */
  }
  const nav = typeof navigator !== 'undefined' ? navigator.language.slice(0, 2) : 'en'
  return isLocale(nav) ? nav : 'en'
}

export const i18n = createI18n({
  legacy: false,
  locale: initial(),
  fallbackLocale: 'en',
  messages: { en, lv, ru },
})

export function setLocale(l: string) {
  if (!isLocale(l)) return
  i18n.global.locale.value = l
  document.documentElement.lang = l
  try {
    localStorage.setItem(KEY, l)
  } catch {
    /* storage unavailable */
  }
}

export const formatDate = (iso: string) =>
  new Date(iso).toLocaleString(i18n.global.locale.value, { dateStyle: 'medium', timeStyle: 'short' })
